<template>
  <div>
    <v-alert v-if="error" type="error" class="mb-0">{{ error }}</v-alert>
    <div v-else>
      <users-highlights class="mb-4" />
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        :search="search"
        dense
        :items-per-page="15"
        :footer-props="{ 'items-per-page-options': [15, 50, 100, 250, 500] }"
        sort-by="createdAt"
        sort-desc
      >
        <template v-slot:top>
          <div class="d-flex align-center flex-wrap gap-2 mb-2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filtrar lista"
              single-line
              hide-details
              outlined
              dense
              class="flex-grow-1"
            />
            <v-btn color="primary" depressed @click="openSearch">
              <v-icon left>mdi-account-search</v-icon>
              Buscar cliente
            </v-btn>
          </div>
        </template>

        <template v-slot:item.name="{ item }">
          <v-avatar v-if="!item.name" :size="24" class="mr-2">
            <v-icon>mdi-account-question</v-icon>
          </v-avatar>
          <base-avatar
            v-else
            :src="item.photo"
            :seed="item.id"
            :size="24"
            class="mr-2"
          />
          <i class="text-12" v-if="!item.name">Conta não criada</i>
          <span v-else>{{ item.name }}</span>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip
            :color="
              !item.active ? 'error' : !item.complete ? 'warning' : 'success'
            "
            label
            x-small
            class="w-full justify-center px-2"
          >
            {{
              !item.active ? "Inativo" : !item.complete ? "Incompleto" : "Ativo"
            }}
          </v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
              </span>
            </template>
            <span>{{ [item.createdAt] | dateDiff(true) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="userDetailsModal(item)">
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <user-search-modal ref="searchModal" />
    <user-details-modal />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import USERS from "@/services/ultimate/users";
import UsersHighlights from "./UsersHighlights.vue";
import UserDetailsModal from "./UserDetailsModal.vue";
import UserSearchModal from "./UserSearchModal.vue";

export default {
  components: { UsersHighlights, UserDetailsModal, UserSearchModal },
  data: () => ({
    search: "",
    users: [],
    loading: false,
    error: null,
  }),
  methods: {
    userDetailsModal(user) {
      this.$root.$emit("user-details-modal", user);
    },
    openSearch() {
      this.$refs.searchModal.open();
    },
    onUserUpdated(user) {
      const index = this.users.findIndex((item) => item.id === user?.id);
      if (index < 0) return;
      this.users.splice(index, 1, {
        ...this.users[index],
        name: user.name,
        email: user.email,
        document: user.document,
        active: user.active,
      });
    },
    async getUsers() {
      this.loading = true;
      try {
        const response = await USERS.getUsers();
        this.users = response.users;
      } catch (error) {
        this.error = error.message || "Erro ao buscar usuários";
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission", "hasUltimatePermission"]),
    headers() {
      return [
        // { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Telefone", value: "phone", align: "center" },
        { text: "Email", value: "email", align: "center" },
        this.canSeeSensitiveData
          ? { text: "Documento", value: "document", align: "center" }
          : null,
        { text: "Situação", value: "active", align: "center", sortable: false },
        { text: "Criado em", value: "createdAt", align: "center" },
        { text: "", value: "actions", sortable: false },
      ].filter((header) => header);
    },
    canSeeSensitiveData() {
      return this.hasUltimatePermission("*") || this.hasPermission(65536);
    },
  },
  created() {
    this.getUsers();
  },
  mounted() {
    this.$root.$on("user-updated", this.onUserUpdated);
  },
  beforeDestroy() {
    this.$root.$off("user-updated", this.onUserUpdated);
  },
};
</script>

<style></style>
